// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"RadiusFilter-module--sliderContainer"};